import userApi from '@/api/user'

const state = {
  user: null,
  currentProjectId: null,
  currentCampaignId: null
}

// getters
const getters = {
  isLoggedIn: (state, getters, rootState) => {
    return state.user
  },
  currentProject: (state, getters, rootState) => {
    if (state.user && state.user.projects && state.user.projects.length > 0) {
      return state.user.projects[0]
    }
  },
  currentCampaign: (state, getters, rootState) => {
    if (state.user && state.user.projects && state.user.projects.length > 0) {
      return state.user.projects[0].campaigns[0]
    }
  },
  currentProjectCampaigns: (state, getters, rootState) => {
    if (state.user && state.user.projects && state.user.projects.length > 0) {
      return state.user.projects[0].campaigns || []
    }
    return []
  },
  details: (state, getters, rootState) => {
    return state.user
  }
}

// mutations
const mutations = {
  setUser(state, user) {
    state.user = user
  },
  updateProfile(state, details) {
    state.user.name = details.name
    state.user.role = details.role
    state.user.username = details.username
  }
}
// actions
const actions = {
  signup({ commit, state }, data) {
    return new Promise(function(resolve, reject) {
      userApi
        .signup(data)
        .then(function(res) {
          commit('setUser', res.data.results)
          resolve(res.data.results)
        })
        .catch(function(err) {
          console.log(err)
          reject(err.response.data.errors)
        })
    })
  },
  login({ commit, state }, data) {
    return new Promise(function(resolve, reject) {
      userApi
        .login(data)
        .then(function(res) {
          commit('setUser', res.data.results)
          resolve(res.data.results)
        })
        .catch(function(err) {
          reject(err.response.data.errors)
        })
    })
  },
  getDetails({ commit, state }, data) {
    return new Promise(function(resolve, reject) {
      userApi
        .getDetails(data)
        .then(function(res) {
          commit('setUser', res.data.results)
          resolve(res.data.results)
        })
        .catch(function(err) {
          reject(err.response.data.errors)
        })
    })
  },
  updateDetails({ commit, state }, data) {
    return new Promise(function(resolve, reject) {
      userApi
        .updateDetails(data)
        .then(function(res) {
          commit('updateProfile', res.data.results)
          resolve(res.data.results)
        })
        .catch(function(err) {
          reject(err.response.data.errors)
        })
    })
  },
  onboardingComplete({ commit, state }, data) {
    return new Promise(function(resolve, reject) {
      userApi
        .onboardingComplete(data)
        .then(function(res) {
          // commit('setUser', res.data.results)
          resolve(res.data.results)
        })
        .catch(function(err) {
          reject(err.response.data.errors)
        })
    })
  },
  logout({ commit, state }, data) {
    return new Promise(function(resolve, reject) {
      userApi
        .logout(data)
        .then(function(res) {
          commit('setUser', null)
          resolve()
        })
        .catch(function(err) {
          reject()
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
